<div
  *transloco="let t; read: 'metric-settings-pill'"
  class="metric-settings-pill__container"
  [class.metric-settings-pill__container--disabled]="isDisabled"
  (click)="onOpenModal()"
>
  <pre><b>{{ t('main-metric') }}:</b> {{ predictiveOptions.mainSettings | metricSettings }} | <b>{{ t('driver') }}:</b> {{ predictiveOptions.driverSettings | metricSettings }}</pre>
</div>

@if (isModalVisible) {
  <app-lex-xi-modal [isVisible]="isModalVisible" maxWidth="800px" (close)="onCloseModal(null)">
    <ng-template appXIModalContent>
      @if (isModalVisible) {
        <app-metric-settings-modal
          [predictiveOptions]="predictiveOptions"
          (close)="onCloseModal($event)"
        ></app-metric-settings-modal>
      }
    </ng-template>
  </app-lex-xi-modal>
}
